// extracted by mini-css-extract-plugin
export default {"MobileNavigation":"MobileNavigation_MobileNavigation__l8V00","NavLogo":"MobileNavigation_NavLogo__U09qD"};